import { Injectable } from '@angular/core';
import { DictionaryField } from '@gk/gk-modules';
import { Observable, of } from 'rxjs';
import { PARActType } from './act-type.model';

@Injectable({
  providedIn: 'root',
})
export class PARActTypeService {
  private readonly actTypes: DictionaryField[] = [
    new DictionaryField(
      PARActType.CommunityGeneralPlan,
      'PLANNING_ACT_REQUEST.ACT_TYPE.COMMUNITY_GENERAL_PLAN',
    ),
    new DictionaryField(
      PARActType.DevelopmentPlan,
      'PLANNING_ACT_REQUEST.ACT_TYPE.DEVELOPMENT_PLAN',
    ),
    new DictionaryField(
      PARActType.SmallArchitectureResolution,
      'PLANNING_ACT_REQUEST.ACT_TYPE.SMALL_ARCHITECTURE_RESOLUTION',
    ),
  ];
  private actTypeDictionary: Observable<DictionaryField[]>;

  get(): Observable<DictionaryField[]> {
    if (!this.actTypeDictionary) {
      this.actTypeDictionary = of(this.actTypes);
    }
    return this.actTypeDictionary;
  }
}
